export default __webpack_public_path__ + "locales/nl/RoomLogoCover.json?hash=713add1c280c283b92c8359fe3b0eab6";